import React from 'react';
import cx from 'classnames';
import './Select.scss';

function Option({ name, value }) {
    return (
        <option key={name} value={value}>
            {name}
        </option>
    );
}

function Select({ options, name, placeholder, onChange, value, hasLabel=true, selectHasError=false }) {
    const disabled = !options?.length;

    return (
        <div className='ppq--web--select'>
          { hasLabel &&
            <label htmlFor={`ppq-web-select-${name}`} className='ppq--web--select--label'>
              {name}
            </label>
          }
            <select
                onChange={onChange}
                value={value || placeholder}
                id={`ppq-web-select-${name}`}
                data-testid={`ppq-web-select-${name}`}
                className={cx('ppq--web--select--body', { 'ppq--web--select--disabled': disabled }, { 'prequal--web--select-has-error': selectHasError }, {'ppq--web--select--no-selected-value': value===''})}
            >
                {!disabled ? (
                    <option key={placeholder} disabled value={placeholder} hidden>
                        {placeholder}
                    </option>
                ) : null}
                {options?.map(Option)}
            </select>
        </div>
    );
}

export default Select;
